import React from "react";
import InnerHaeder from "../Component/InnerHaeder";
import Highlights from "../Component/Highlights";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import HeadTag from "../Component/HeadTags";
import LazyLoad from "react-lazyload";
const ExperientialLearning = () => {
  return (
    <>
      <HeadTag title="Experiential Learning" />
      <Highlights />
      <InnerHaeder />
      <div className="inner_page">
        <div className="container-fluid flwidth">
          <div className="bgimage">
            <h5>
              <Link to="/">
                {" "}
                Home <i className="fas fa-angle-right"></i>{" "}
              </Link>
              <span>
                {" "}
                Academics <i className="fas fa-angle-right"></i> Experiential
                Learning{" "}
              </span>
            </h5>
            <h2> Experiential Learning</h2>
          </div>
          <h3>
            <center>
              <b>REPORT - 2025 </b>
            </center>
          </h3>
          <div className="row acheivement_2024">
            <div className="col-md-12">
              <h3>Summer Internship Highlights </h3>
              <p>
                <b>Date:</b> 15 Jul 2025{" "}
              </p>
              <p>
                This summer proved to be an extraordinary chapter of
                experiential learning and professional exploration for our
                students, as they engaged in a series of impactful internships
                meticulously curated to provide hands-on exposure, deepen
                subject knowledge, and cultivate real-world competencies.{" "}
              </p>

              <p>
                At Delhi Metropolitan Education (26th–30th May), students delved
                into the multifaceted realms of media, law, and
                entrepreneurship. They acquired the fundamentals of filmmaking,
                including scriptwriting, camera techniques, and various
                production stages. Their understanding of legal research and
                academic paper writing was strengthened, while storytelling
                through Panchatantra tales introduced them to the nuances of
                radio production and management. Furthermore, the SCAMPER model
                facilitated their exploration of innovative and creative
                business planning strategies. The program culminated in
                reflective activities on mental well-being and a valedictory
                ceremony graced by Mr. Amit Bhatia from ABP News, which
                motivated the participants immensely.{" "}
              </p>

              <p>
                At Unique Psychological Services (17th–21st June), students
                gained profound insights into psychological assessments,
                including the Mental Status Examination (MSE) and projective
                tests. They engaged in analytical case studies on disorders such
                as Asperger’s Syndrome and depression, and honed their
                counselling skills, focusing on empathy, effective listening,
                and goal-setting. Activities like the "Rose-Bud-Thorn"
                reflection exercise nurtured their emotional awareness,
                self-reflection, and introspective thinking, enabling them to
                develop deeper psychological insight.{" "}
              </p>

              <p>
                The Fortis Internship Program (16th–21st June) offered
                comprehensive exposure to mental health and behavioural
                sciences. Students explored disorders such as ADHD and PTSD,
                examined therapeutic modalities like Cognitive Behavioural
                Therapy (CBT), and delved into concepts in social psychology.
                Discussions centred around reducing stigma associated with
                mental health disorders and enhancing community mental health
                awareness, thereby fostering socially responsible perspectives
                among the interns.{" "}
              </p>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship25-1.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship25-2.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship25-3.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship25-4.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship25-5.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship25-6.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship25-7.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship25-8.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship25-9.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
          </div>
          {/* <div className="row acheivement_2024">
          <div className='col-md-4'>
              <div className="img-block">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/digital-drama.png" className="img-fluid" alt="Lotus Valley International School, Greater Noida" />
              </div>
            </div>
            <div className='col-md-8'>
              <h3>Digital Drama</h3>
              <p><b>Position: </b> Second Position</p>
              <p><b>Date:</b> July 20, 2024</p>
              <p>We are happy to share the latest achievements of our young learners in the inter-school competition held at GD Goenka Indirapuram on July 20, 2024 . Learners from Primary wing enthusiastically participated and brought laurels in the following categories : </p>
              <p>Participants - </p>
              <ul>
                <li>Advith Singh III Alexander</li>
                <li>Ayaan Tayal III Augustus</li>
                <li>Saanvi Mishra IV Takshila</li>
                <li>Aarvi Bhatia  IV Takshila</li>
                <li>Amyra Rawat IV Oxford </li>
                <li>Naisha Srivastava IV Oxford</li>
                <li>Kiaan Singh IV Georgia</li>
                <li>Amaira Rai III Shivaji</li>
              </ul>
            </div>          

          </div>
          <div className="row acheivement_2024">
          <div className='col-md-4'>
              <div className="img-block">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/dictum-factum.jpg" className="img-fluid" alt="Lotus Valley International School, Greater Noida" />
              </div>
            </div>
            <div className='col-md-8'>
              <h3>Dictum Factum</h3>
              <p><b>School: </b> Somerville School,Noida</p>
              <p><b>Event:</b> Dictum Factum </p>
              <p><b>Date:</b> 9th July,2024</p> 
              <p>We are thrilled to announce the outstanding achievement of young learners of primary wing at the Incognito - An Interschool Technical Competition organised by Somerville School,Noida on 29th July,2024 has secured third position in   Dictum Factum event.</p>
              <p>Heartiest congratulations to the winners and their Mentor!</p>
               
            </div>

            

          </div> */}
          <h3>
            <center>
              <b>REPORT - 2024 </b>
            </center>
          </h3>
          <div className="row acheivement_2024">
            <div className="col-md-12">
              <h3>World of Work - Summer Internship Programme</h3>
              <p>
                <b>Date:</b> 27 June 24
              </p>
              <p>
                At Lotus Valley International School Noida Extension, we believe
                in the power of experiential learning. This summer, our students
                from Classes XI & XII took part in our Summer Internship
                Programme '24 - World of Work.
              </p>
              <p>
                In collaboration with organizations such as Delhi Metropolitan
                Education, Fortis Healthcare, Unique Psychology Services, Rachna
                Sagar Pvt. Ltd., Jitin Chawla Centre for Career Development,
                Edutri, our parent organization Arsenal Infosolutions Pvt. Ltd.,
                and Pravisht Digital, our students explored various fields
                including Financial Planning, Photography, Moot Court,
                Marketing, Video Editing, IT, HR, Technology, Psychology, and
                many more.
              </p>
              <p>
                These hands-on experiences provided our students with valuable
                skills, professional insights, self-confidence, and leadership
                abilities. We are proud of their dedication and enthusiasm,
                which reflect the core values of Lotus Valley International
                School, Noida Extension. Here's to their continued growth and
                success!
              </p>
              <p>
                #LotusValleyNoida Extension #Internship #WorldOfWork
                #ExperientialLearning #StudentSuccess #Leadership
                #ProfessionalDevelopment
              </p>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship1.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship2.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship3.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship4.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship5.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship6.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship7.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship8.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship9.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship10.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship11.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship12.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship13.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship14.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship15.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship16.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship17.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship18.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship19.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-3">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/summer_internship20.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
          </div>
          <div className="row acheivement_2024">
            <div className="col-md-4">
              <div className="img-block">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/fddi_noida.jpg"
                    className="img-fluid"
                    alt="Lotus Valley International School, Greater Noida"
                  />
                </LazyLoad>
              </div>
            </div>
            <div className="col-md-8">
              <h3>Report on Inspiring Educational Visit to FDDI Noida</h3>
              <p>
                <b>Date:</b> 24 May 24
              </p>
              <p>
                The students of Class XI and XII recently visited the Footwear
                Design and Development Institute (FDDI) in Noida, known for its
                expertise in footwear, fashion, and lifestyle product
                design.{" "}
              </p>
              <p>
                The visit began with an informative session by FDDI faculty, who
                discussed the institute ‘s history and admission process.
                Students asked questions about eligibility, applications, and
                important dates, gaining valuable and crucial information for
                their future aspirations.
              </p>
              <p>
                In hands-on workshops, students designed footwear, learning
                about materials, aesthetics, and functionality. A competition
                followed, with three students winning prizes for their
                innovative designs. They also toured labs and interacted with
                industry experts, gaining insights into market demands,
                sustainable practices, and emerging design trends.
              </p>
              <p>
                Overall, the FDDI Noida visit inspired many students to consider
                careers in design and fashion, combining theoretical knowledge
                with practical experience to prepare them for the industry.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="col-md-12">
                <h3>Discovering India Workshop</h3>
                <p>
                  <strong>
                    'The real voyage of discovery consists not in seeking new
                    landscapes, but in having new eyes.’
                  </strong>
                </p>
                <p>
                  Celebrating the rich heritage and vibrant culture of India,
                  LVIS, NE organised a workshop ‘The Soul of Incredible India -
                  Odisha’ on Saturday, 11 December 2021, for the learners of
                  grade III. Pursuing the vision of the school Principal, Ms.
                  Indu Yadav and in concurrence with the CBSE roadmap,
                  Discovering India is a programme that inspires young learners
                  to explore the treasures of Incredible India. This workshop
                  contributed immensely in providing the learners to experience
                  the culture of the state of the month- Odisha.
                </p>
                <p>
                  Odisha was charmingly introduced by Ms. Nimisha, the talented
                  dance facilitator. Through her mesmerizing Odissi dance
                  performance, she spellbound the audience with her aesthetic
                  costume, hast mudras and graceful expressions.
                </p>
                <p>
                  Next, the guest speaker, Ms. Aparnashree Mishra, a parent of
                  LVIS NE and a native of Sambalpur district of Western Odisha,
                  nostalgically articulated the geography and history of Odisha.
                  She spoke about the enchanting beauty of the untouched
                  landscapes, the traditions behind famous festivals like the
                  Rath Yatra, Pipli handicrafts, the folk dance and famed
                  Sambalpuri Sarees. This glorious overview enriched learners
                  with the unparalleled grandeur of the state.
                </p>
                <p>
                  While sharing some of the traditional delicacies from the
                  state, Ms Aparnashree demonstrated an interesting recipe of
                  Chhena Poda which the learners enthusiastically prepared along
                  with her.
                </p>
                <p>
                  An inspiring message from the principal, Ms Indu Yadav urged
                  the young lotusians to continue their exploration of the
                  uniqueness that their country offers.
                </p>
                <div className="clr"></div>
                <h3>Discovering India</h3>
                <p>
                  <strong>
                    "India is the one land that all men desire to see, and
                    having seen once, by even a glimpse, would not give that
                    glimpse for all the shows of all the rest of the globe
                    combined.""
                  </strong>
                </p>
                <p>
                  Our country is a rich tapestry of culture, traditions and
                  valiant folklore. To celebrate the rich diversity and culture
                  of this great nation, ‘Discovering India Week’ was organised
                  for the learners of the Primary Wing of Lotus Valley
                  International School, Noida Extension, from 9 to 13 August,
                  2021.
                </p>
                <p>
                  As citizens of this great nation, learners of the Primary Wing
                  embarked on a journey to discover the affluent heritage and
                  strive to uphold the values that have been passed on through
                  generations, each day. The week was privy to celebrations of
                  cultures, values and traditions that together contribute to
                  the secularism of India. The discovering India week was rife
                  with a multitude of activities including virtual tours to
                  historical sites and monuments, and local traditions and
                  cultures surrounding cuisines, music, dance and attire. They
                  indulge in activities to highlight the local craftsmanship of
                  the states of Punjab, Rajasthan and Maharashtra, like Warli
                  painting, blue pottery, etc. The students also donned the hats
                  of chefs to recreate famous local delicacies in fireless
                  cooking activities. To culminate the week of celebration, they
                  took on the roles of famous people from all across India in
                  the stirring and spirited character parade. Parents,
                  grandparents and students performed folk dances and celebrated
                  the cultural fest.
                </p>
                <p>
                  This week of celebration and discovery of India brought to
                  light the patriotic spirit that is instilled in each one of
                  us, and the happiness of being part of a great legacy.
                </p>
                <div className="clr"></div>
                <h3>International Yoga Day</h3>
                <p>
                  <strong>
                    'Yoga is the artwork of awareness on the canvas of body,
                    mind and soul'
                  </strong>
                </p>
                <p>
                  Yoga is an invaluable gift of India to the world. It embodies
                  the unity of mind and body and thoughts and actions. Students,
                  parents and teachers of LVIS, NE came together to celebrate
                  the 7th International Yoga Day with a virtual yoga session led
                  by the school’s yoga instructors Ms. Jyoti and Ms. Sulochana.
                  The audience performed various asanas like suryanamaskara,
                  dhanurasana, ardha ushtrasana and pranayama while also
                  discovering the benefits of each asana promoting good health
                  and well being.
                </p>
                <p>
                  The session was a reminder of the ability of this traditional
                  form of exercise to optimally blend physical and mental
                  disciplines in a way that alleviates stress and improves
                  vitality. The school Principal Ms. Indu Yadav, in her welcome
                  address, reverberated the need to be mindful about our
                  lifestyles and to create a consciousness that pledges a system
                  of harmony between man and nature.
                </p>
                <p>
                  As the session drew to a close, each member of the audience
                  found themselves to be peaceful, composed and in-sync with
                  their inner self.
                </p>
                <div className="clr"></div>
                <h3>Student Led Conference</h3>
                <p>
                  In our endeavour to ignite the spirit of inquiry and enable
                  learners to communicate confidently as future global
                  ambassadors , LVIS ,NE organised its first ever Student Led
                  Parent Conference during the Nature Nurture week on Friday,
                  23rd April 2021. The students of grades IV-V led the
                  conference with panache and poise. Our collaborative partners
                  , parents were invited and young environmentalists put across
                  their concerns and questions related to the prevailing climate
                  issues. The parents addressed each of these questions,
                  welcoming different perspectives and widening the scope of
                  discussion for all . Apart from enhancing the student’s
                  critical thinking skills, this synergy added value in
                  identifying the environmental issues, ways to mitigate them at
                  individual level and think of the bigger picture.
                </p>
                <div className="clr"></div>
                <h3>World Book Day</h3>
                <p>
                  <strong>
                    "Books are the quietest and most constant of friends; they
                    are the most accessible and wisest of counsellors, and the
                    most patient of teachers."
                  </strong>
                </p>
                <p>
                  Books are the gifts that one must not forget to open time and
                  again. Lotus Valley International School, Noida Extension
                  celebrated the World Book Day on April 23, 2021 to kindle the
                  love for reading amongst the learners. On April 23, UNESCO too
                  celebrates World Book Day which also marks the death
                  anniversary of the literary giant William Shakespeare.
                  Commemorating the event, the young readers of LVIS,NE,
                  participated in different activities like ‘Bookmark Designing’
                  with motivational quotes, ‘Book Cover Designing’ and ‘Summary
                  Narration’ with twisted endings. The school’s relentless
                  efforts to promote reading paid off as not just the students
                  but also many parents felt motivated and chose to squeeze time
                  out of their busy schedules to read with their young ones. The
                  Weekly Book Discussion activity was initiated on this day
                  wherein students along with their class teachers
                  enthusiastically attended Pre-Reading activities based on the
                  supplementary books prescribed to them. Children felt
                  transported to a different world, experiencing the joy of
                  travelling without moving out of the comfort of their houses
                  while they read their books.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ExperientialLearning;
